import styled from "styled-components";

export const Button = styled.button`
  background-color:${props => props.disabled ? '#A5A5A5' : '#3c3cff'};
  border: none;
  margin-right: 10px;
  min-width: 200px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  border-radius: 5px;
  color: #fff;
  font-weight: 600;

  &:hover {
    ${props => !props.disabled && 'filter: brightness(0.8);'}
  }

  span {
    width: 20px;
    height: 20px;
    margin: 0 auto !important;
    border-radius: 50%;
    border: 1px solid #000;
    border-top: 1px solid #fff;
    animation: spin 0.6s linear infinite;

    @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  }
`
